"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rUpper = /([A-Z])/g;
function hyphenate(s) {
    return s.replace(rUpper, '-$1').toLowerCase();
}
exports.hyphenate = hyphenate;
